/* <!-- Legal templates pending review by qualified counsel before production --> */
import { HELP_EMAIL } from "@/constants/links";

import { LEGAL_LAST_UPDATED } from "./legalDate";
import LegalShell from "./LegalShell";

export default function Privacy() {
    return (
        <LegalShell
            title="Privacy Policy"
            lastUpdated={LEGAL_LAST_UPDATED}
            testId="privacy-page"
        >
            <p className="core-legal-lede">
                Core Billion operates C-ORE C-Suites. This policy explains
                what we collect, how we use it, how we protect it, and the
                rights you have over your data.
            </p>

            <section className="core-legal-section">
                <h2>Data collection</h2>
                <p>
                    We collect: (a) account details such as your name,
                    business name, email and phone number; (b) business and
                    financial data you choose to sync from connected tools
                    such as Tally, Zoho, QuickBooks and GST systems; and
                    (c) product usage and device information that helps us
                    operate and improve the service.
                </p>
            </section>

            <section className="core-legal-section">
                <h2>Data usage</h2>
                <p>
                    We use your data to deliver your C-Suite intelligence,
                    generate dashboards, alerts and reports, provide
                    support, and improve reliability and security. We do
                    not sell your personal or financial data to anyone.
                </p>
            </section>

            <section className="core-legal-section">
                <h2>Data protection</h2>
                <p>
                    Your data is encrypted in transit and at rest and
                    stored on access-controlled servers. Only you and the
                    users you authorise — including a CA or accountant you
                    grant access to — can view your business data. We work
                    with vetted service providers who process data on our
                    behalf under confidentiality obligations.
                </p>
            </section>

            <section className="core-legal-section">
                <h2>Customer rights</h2>
                <p>
                    Under India's Digital Personal Data Protection Act,
                    2023, you may request access to, correction of, or
                    erasure of your personal data, and may withdraw consent
                    at any time. To exercise these rights or raise a
                    grievance, contact our Grievance Officer at{" "}
                    <a
                        href={`mailto:${HELP_EMAIL}`}
                        data-testid="privacy-grievance-email"
                    >
                        {HELP_EMAIL}
                    </a>
                    . We retain data while your account is active and as
                    required by law, after which we delete or anonymise
                    it.
                </p>
            </section>

            <section className="core-legal-section">
                <h2>Contact</h2>
                <p>
                    <a
                        href={`mailto:${HELP_EMAIL}`}
                        data-testid="privacy-contact-email"
                    >
                        {HELP_EMAIL}
                    </a>
                </p>
            </section>
        </LegalShell>
    );
}
